import api from './api';

/**
 * API Key management service (Enterprise tier)
 */
export const apiKeysService = {
  /**
   * Get all API keys for the business
   */
  getAll: () => api.get('/apikeys'),

  /**
   * Get a specific API key by ID
   */
  getById: (id) => api.get(`/apikeys/${id}`),

  /**
   * Create a new API key
   * @param {Object} data - { name, description?, scopes?, expiresAt? }
   * @returns {Promise} - Contains the full API key (only shown once!)
   */
  create: (data) => api.post('/apikeys', data),

  /**
   * Update an API key's metadata
   * @param {number} id - API key ID
   * @param {Object} data - { name?, description?, scopes?, expiresAt? }
   */
  update: (id, data) => api.put(`/apikeys/${id}`, data),

  /**
   * Revoke an API key (soft delete)
   * @param {number} id - API key ID
   * @param {string} reason - Optional reason for revocation
   */
  revoke: (id, reason = null) => api.post(`/apikeys/${id}/revoke`, { reason }),

  /**
   * Permanently delete an API key
   * @param {number} id - API key ID
   */
  delete: (id) => api.delete(`/apikeys/${id}`),

  /**
   * Get API usage statistics
   */
  getUsageStats: () => api.get('/apikeys/usage'),

  /**
   * Get available scopes
   */
  getScopes: () => api.get('/apikeys/scopes'),
};

export default apiKeysService;